import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { getDuration } from "utils/time";

import { ScanRunsListItem } from "../../../types";

const ScanRunsTableDurationCell = ({
  item: run,
  ...cellProps
}: TableSimpleCellProps<ScanRunsListItem>) => {
  const duration = getDuration(run.duration, true, false);

  return (
    <TableSimpleCell {...cellProps}>
      {duration ? <TableCellText>{duration}</TableCellText> : <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default ScanRunsTableDurationCell;
